module.exports = __webpack_public_path__ + "static/media/background-image.aefdfc0f.png";